import { render, staticRenderFns } from "./CoursesEffectModal.vue?vue&type=template&id=1dde3e5c&"
import script from "./CoursesEffectModal.vue?vue&type=script&lang=js&"
export * from "./CoursesEffectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports